/**
 * Drupal Tools library.
 */
(function ($) {
  'use strict';

  /**
   * Drupal ToolsHelper object.
   */
  Drupal.ToolsHelper = Drupal.ToolsHelper || {};
  Drupal.ToolsHelper.components = {
    $window: null,
    $document: null,
    $header: null,
    $footer: null,
  };
  Drupal.ToolsHelper.ModalSpinner = {
    queue: [],
  };

  /**
   * Capitalizes first letter.
   * @returns {string} Capitalized string.
   */
  String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
  };

  /**
   * Alters the given object to removes elements with null or undefined values.
   *
   * @param {object} obj given object
   * @returns {string} output
   */
  Drupal.ToolsHelper.filterObj = function (obj) {
    for (const [key, value] of Object.entries(obj)) {
      if (value === null) {
        delete obj[key];
      }
    }
  };

  /**
   * Get URL parameter
   *
   * @param {string} sParam
   *   Retrieving parameters from the url
   * @param {number|string|null} [defaultValue]
   *   Default value, if search parameter is not found. `''` by default
   * @returns {number|string|null} Value of sParam
   */
  Drupal.ToolsHelper.getUrlParameter = function (sParam, defaultValue) {
    defaultValue = typeof defaultValue !== 'undefined' ? defaultValue : '';
    const results = new RegExp('[?&]' + RegExp.rpEscape(sParam) + '(?:=([^&#]*)|[#&]|$)').exec(window.location.href);
    return (results !== null && typeof results[1] !== 'undefined') ? decodeURI(results[1]) : defaultValue;
  };

  /**
   * Get URL parameters
   *
   * @param {string} sParam
   *   Retrieving parameters from the url
   * @param {number|string|null} [defaultValue]
   *   Default value, if search parameter is not found. `''` by default
   * @returns {number[]|string[]|string|null} Value of sParam
   */
  Drupal.ToolsHelper.getUrlParameters = function (sParam, defaultValue) {
    defaultValue = typeof defaultValue !== 'undefined' ? defaultValue : '';
    const url = window.location.href;
    const regex = new RegExp('[?&]' + RegExp.rpEscape(sParam) + '(?:=([^&#]*)|[#&]|$)', 'g');
    const values = [];
    let match;

    while ((match = regex.exec(url)) !== null) {
      values.push(decodeURI(match[1]));
    }

    return values.length > 0 ? values : defaultValue;
  };

  /**
   * Generates a get Url.
   *
   * @param {string} basePath
   *   Given url basepath.
   * @param {object} params
   *   Given object, containing get parameters and values.
   * @returns {string}
   *   Generated URL.
   */
  Drupal.ToolsHelper.generateGetUrl = function (basePath, params) {

    const parameters = Object.keys(params)
      .map((k) => {
        if (Array.isArray(params[k])) {
          // If the parameter is a list, generate key/value pars for each
          // element of the list.
          return params[k].map((value) => {
            return value !== null && value !== '' ? encodeURIComponent(k) + '=' + encodeURIComponent(value) : null;
          });
        }
        else {
          return params[k] !== null ? encodeURIComponent(k) + '=' + encodeURIComponent(params[k]) : null;
        }
      })
      .filter((x) => x !== null)
      .flat()
      .join('&');

    return basePath + (parameters !== '' ? '?' + parameters : '');
  };

  /**
   * Returns internal taxonomy key from eventual aliases.
   *
   * @param {string} taxonomyKey
   *   Given key.
   * @returns {string}
   *   Computed key.
   */
  Drupal.ToolsHelper.normalizeTaxonomyKey = function (taxonomyKey) {
    switch (taxonomyKey) {
      case 'oe1':
        return 'corporate_department';
      case 'oe2':
        return 'corporate_section';
      case 'oe3':
        return 'corporate_team';
    }
    return taxonomyKey;
  };

  /**
   * Gets all taxonomies from drupalSettings.
   *
   * @returns {object|null}
   *   DrupalSettings taxonomies object. Null if missing.
   */
  Drupal.ToolsHelper.getAllTaxonomies = function () {
    return typeof drupalSettings.taxonomy !== 'undefined' ? drupalSettings.taxonomy : null;
  };

  /**
   * Gets a taxonomy from drupalSettings thanks to it's key.
   *
   * @param {string} taxonomyKey
   *   Key of the Taxonomy.
   *
   * @returns {array|null}
   *   DrupalSettings taxonomies object. Null if missing.
   */
  Drupal.ToolsHelper.getTaxonomyByKey = function (taxonomyKey) {
    taxonomyKey = this.normalizeTaxonomyKey(taxonomyKey);
    const allTaxonomies = Drupal.ToolsHelper.getAllTaxonomies();
    return allTaxonomies !== null && typeof allTaxonomies[taxonomyKey] !== 'undefined' ? allTaxonomies[taxonomyKey] : null;
  };

  /**
   * Gets a taxonomy term from drupalSettings thanks to it's key / id.
   *
   * Will search for element with the property "id" or "key".
   *
   * @param {string} taxonomyKey
   *   Key of the Taxonomy.
   * @param {string} searchCriteria
   *   Search criteria of the searched taxonomy term.
   *
   * @returns {object|null}
   *   DrupalSettings taxonomies term object. Null if missing.
   */
  Drupal.ToolsHelper.getTaxonomyTerm = function (taxonomyKey, searchCriteria) {
    const taxonomy = Drupal.ToolsHelper.getTaxonomyByKey(taxonomyKey);
    const taxonomyTerm = taxonomy.find(function (item) {
      return item.id === searchCriteria || item.key === searchCriteria || item.modelKey === searchCriteria;
    });
    return typeof taxonomyTerm !== 'undefined' ? taxonomyTerm : null;
  };

  /**
   * Gets a translation from drupalSettings thanks to given key.
   *
   * Sometimes, Drupal.t() javascript function is not working well when using
   * variables, so we are passing some translations in drupalSettings instead.
   *
   * @param {string} key
   *   Given translation key.
   *
   * @returns {string}
   *   Translation if found, returns given key if not found.
   */
  Drupal.ToolsHelper.getTranslation = function (key) {
    return typeof drupalSettings.translations !== 'undefined' &&
    typeof drupalSettings.translations[key] !== 'undefined'
      ? drupalSettings.translations[key] : key;
  };

  /**
   * Shows global modal spinner.
   *
   * @returns {undefined}
   */
  Drupal.ToolsHelper.ModalSpinner.show = function () {
    UIkit.modal(jQuery('#modal-spinner')).show();
  };

  /**
   * Shows global modal spinner.
   *
   * @returns {undefined}
   */
  Drupal.ToolsHelper.ModalSpinner.hide = function () {
    UIkit.modal(jQuery('#modal-spinner')).hide();
  };

  /**
   * Register to Modal Spinner. Will trigger show method.
   *
   * @param {string} key
   *   Given register key.
   *
   * @returns {undefined}
   */
  Drupal.ToolsHelper.ModalSpinner.register = function (key) {
    this.queue.push(key);
    this.show();
  };

  /**
   * Dismiss from Modal Spinner. If queue is empty, trigger hide method.
   *
   * @param {string} key
   *   Given register key.
   *
   * @returns {undefined}
   */
  Drupal.ToolsHelper.ModalSpinner.dismiss = function (key) {
    this.queue = this.queue.filter(item => item !== key);
    if (this.queue.length === 0) {
      this.hide();
    }
  };

  /**
   * Returns rgba color from given rbg object.
   *
   * @param {{r:int,g:int,b:int}} rgbColor
   *   Given RBG object color.
   * @param {string} [opacity]
   *   Given opacity, as string. 1 by default.
   *
   * @returns {string}
   *   Rgba color property.
   */
  Drupal.ToolsHelper.getColorFromRgbColor = function (rgbColor, opacity) {
    opacity = typeof opacity !== 'undefined' ? opacity : 1;
    opacity = opacity !== null && opacity.length !== 0 ? opacity : 1;
    return `rgba(${rgbColor.r},${rgbColor.g},${rgbColor.b},${opacity})`;
  };

  /**
   * Gets page header.
   *
   * @returns {jQuery}
   *   JQuery Element.
   */
  Drupal.ToolsHelper.getHeader = function () {
    if (this.components.$header === null) {
      this.components.$header = $('header');
    }
    return this.components.$header;
  };

  /**
   * Gets page footer.
   *
   * @returns {jQuery}
   *   JQuery Element.
   */
  Drupal.ToolsHelper.getFooter = function () {
    if (this.components.$footer === null) {
      this.components.$footer = $('footer');
    }
    return this.components.$footer;
  };

  /**
   * Gets page window.
   *
   * @returns {jQuery}
   *   JQuery Element.
   */
  Drupal.ToolsHelper.getWindow = function () {
    if (this.components.$window === null) {
      this.components.$window = $(window);
    }
    return this.components.$window;
  };

  /**
   * Gets page document.
   *
   * @returns {jQuery}
   *   JQuery Element.
   */
  Drupal.ToolsHelper.getDocument = function () {
    if (this.components.$document === null) {
      this.components.$document = $(document);
    }
    return this.components.$document;
  };

  /**
   * Validates that the given object contains all the given keys.
   *
   * Throws an error if missing.
   *
   * @param {object} config
   *   Given object to check.
   * @param {string[]} keys
   *   List of keys to check.
   *
   * @returns {undefined}
   */
  Drupal.ToolsHelper.checkConfig = function (config, keys) {
    for (const key of keys) {
      if (typeof config[key] === 'undefined') {
        throw new Error('Missing key "' + key + '" in config.');
      }
    }
  };

  /**
   * Lowercase given object keys.
   *
   * @param {object} obj
   *   Given object.
   * @returns {object}
   *   Altered object.
   */
  Drupal.ToolsHelper.lowerCaseObjectKeys = function (obj) {
    return Object.fromEntries(
      Object.entries(obj).map(([k, v]) => [k.toLowerCase(), v])
    );
  };

})(jQuery);

